import { NavigationItem } from './account-navigation.component';

export const b2bNavigationItems: NavigationItem[] = [
  // the account overview is always listed first
  { id: 'my-account', localizationKey: 'account.my_account.overview.link', routerLink: '/account' },
  {
    id: 'my-favorite',
    localizationKey: 'account.my_favorite.heading',
    icon: 'bi-star-fill',
    isCollapsed: true,
    children: [],
  },
  {
    id: 'my-purchases',
    localizationKey: 'account.requisitions.purchases',
    icon: 'bi-cart-fill',
    isCollapsed: true,
    children: [
      {
        id: 'orders',
        localizationKey: 'account.order_history.link',
        routerLink: '/account/orders',
        notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
      },
      {
        id: 'requisitions',
        localizationKey: 'account.requisitions.requisitions',
        routerLink: '/account/requisitions/buyer',
        serverSetting: 'services.OrderApprovalServiceDefinition.runnable',
        permission: 'APP_B2B_PURCHASE',
        notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
      },
      {
        id: 'quotes',
        localizationKey: 'account.navigation.quotes.link',
        routerLink: '/account/quotes',
        feature: 'quoting',
        // CUSTOMIZATION: MVP 2.5.2 — punchout shoppers must reach Quotes to transfer them.
      },
      {
        id: 'order-templates',
        localizationKey: 'account.ordertemplates.link',
        routerLink: '/account/order-templates',
        feature: 'orderTemplates',
      },
      {
        id: 'favorites',
        localizationKey: 'account.favorites.link',
        routerLink: '/account/favorites',
        feature: 'presidioFavorites',
        notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
      },
      {
        id: 'invoices',
        localizationKey: 'account.invoice.page.title',
        routerLink: '/account/invoices',
        feature: 'invoice',
        notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
      },
      {
        id: 'wishlists',
        localizationKey: 'account.wishlists.link',
        routerLink: '/account/wishlists',
        feature: 'wishlists',
        notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
      },
    ],
  },
  {
    id: 'my-approvals',
    localizationKey: 'account.requisitions.myapprovals',
    icon: 'bi-check-lg',
    isCollapsed: true,
    serverSetting: 'services.OrderApprovalServiceDefinition.runnable',
    permission: ['APP_B2B_ORDER_APPROVAL', 'APP_B2B_MANAGE_COSTCENTER'],
    children: [
      {
        id: 'approvals',
        localizationKey: 'account.requisitions.approvals',
        routerLink: '/account/requisitions/approver',
        serverSetting: 'services.OrderApprovalServiceDefinition.runnable',
        permission: ['APP_B2B_ORDER_APPROVAL', 'APP_B2B_MANAGE_COSTCENTER'],
      },
    ],
  },
  // CUSTOMIZATION: Sales Admin (sales-rep + CSR) — price lists, catalogs, work-item respond
  {
    id: 'sales-admin',
    localizationKey: 'account.sales_admin.link',
    icon: 'bi-sliders',
    routerLink: '/account/sales-admin',
    feature: 'presidioSalesAdmin',
    permission: 'APP_B2B_SALES_ADMIN',
    notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
  },
  // CUSTOMIZATION: Presidio Contracts Dashboard (contracts / devices / work items)
  {
    id: 'my-presidio-portal',
    localizationKey: 'account.presidio_portal.heading',
    icon: 'bi-hdd-stack-fill',
    isCollapsed: true,
    feature: 'presidioPortal',
    notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
    children: [
      {
        id: 'contracts',
        localizationKey: 'account.presidio_portal.contracts.link',
        routerLink: '/account/contracts',
        feature: 'presidioPortal',
      },
      {
        id: 'devices',
        localizationKey: 'account.presidio_portal.devices.link',
        routerLink: '/account/devices',
        feature: 'presidioPortal',
      },
      {
        id: 'workitems',
        localizationKey: 'account.presidio_portal.workitems.link',
        routerLink: '/account/workitems',
        feature: 'presidioPortal',
      },
    ],
  },
  // CUSTOMIZATION: Reports is its own My Account section (not under Contracts Dashboard)
  {
    id: 'reports',
    localizationKey: 'account.presidio_portal.reports.link',
    icon: 'bi-bar-chart-fill',
    routerLink: '/account/reports',
    feature: 'presidioPortal',
    notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
  },
  {
    id: 'my-organization',
    localizationKey: 'account.requisitions.organization',
    icon: 'bi-briefcase-fill',
    isCollapsed: true,
    notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
    children: [
      {
        id: 'users',
        localizationKey: 'account.discovery.users.nav',
        routerLink: '/account/organization/users',
        feature: 'presidioDiscovery',
        permission: 'APP_B2B_MANAGE_USERS',
      },
      {
        id: 'manage-addresses',
        localizationKey: 'account.discovery.addresses.nav',
        routerLink: '/account/organization/manage-addresses',
        feature: 'presidioDiscovery',
        permission: 'APP_B2B_MANAGE_USERS',
      },
      {
        id: 'punchout',
        localizationKey: 'account.punchout.link',
        routerLink: '/account/punchout',
        feature: 'punchout',
        permission: 'APP_B2B_MANAGE_PUNCHOUT',
      },
    ],
  },
  {
    id: 'my-profile',
    localizationKey: 'account.profile.myprofile',
    icon: 'bi-gear-fill',
    isCollapsed: true,
    notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
    children: [
      {
        id: 'profile',
        localizationKey: 'account.profile.link',
        routerLink: '/account/profile',
        notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
      },
      {
        id: 'addresses',
        localizationKey: 'account.saved_addresses.link',
        routerLink: '/account/addresses',
        notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
      },
      {
        id: 'payment',
        localizationKey: 'account.payment.link',
        routerLink: '/account/payment',
        notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
      },
      {
        id: 'notifications',
        localizationKey: 'account.notifications.link',
        routerLink: '/account/notifications',
        feature: 'productNotifications',
        notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
      },
    ],
  },
  {
    id: 'logout',
    localizationKey: 'account.navigation.logout.link',
    icon: 'bi-box-arrow-right',
    routerLink: '/logout',
    // CUSTOMIZATION: LOCAL_MOCK punchout shoppers (Pat) must be able to leave the session to switch demo users.
    // Production procurement punchout often omits storefront logout; keep it visible for Presidio demos.
  },
];

// not-dead-code
export const b2cNavigationItems: NavigationItem[] = [
  {
    id: 'my-account',
    localizationKey: 'account.my_account.link',
    icon: 'bi-person-fill',
    routerLink: '/account',
  },
  {
    id: 'orders',
    localizationKey: 'account.order_history.link',
    icon: 'bi-list-ul',
    routerLink: '/account/orders',
    notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
  },
  {
    id: 'wishlists',
    localizationKey: 'account.wishlists.link',
    routerLink: '/account/wishlists',
    icon: 'bi-heart-fill',
    feature: 'wishlists',
    notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
  },
  {
    id: 'notifications',
    localizationKey: 'account.notifications.link',
    routerLink: '/account/notifications',
    feature: 'productNotifications',
    icon: 'bi-bell-fill',
    notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
  },
  {
    id: 'addresses',
    localizationKey: 'account.saved_addresses.link',
    icon: 'bi-geo-alt-fill',
    routerLink: '/account/addresses',
    notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
  },
  {
    id: 'payment',
    localizationKey: 'account.payment.link',
    icon: 'bi-coin',
    routerLink: '/account/payment',
    notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
  },
  {
    id: 'profile',
    localizationKey: 'account.profile.link',
    icon: 'bi-gear-fill',
    routerLink: '/account/profile',
    notRole: ['APP_B2B_CXML_USER', 'APP_B2B_OCI_USER'],
  },
  {
    id: 'punchout',
    localizationKey: 'account.punchout.link',
    icon: 'bi-briefcase-fill',
    routerLink: '/account/punchout',
    feature: 'punchout',
    permission: 'APP_B2B_MANAGE_PUNCHOUT',
  },
  {
    id: 'logout',
    localizationKey: 'account.navigation.logout.link',
    icon: 'bi-box-arrow-right',
    routerLink: '/logout',
    // CUSTOMIZATION: allow punchout demo users to log out (see b2bNavigationItems logout note).
  },
];
